var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { mapState } from 'vuex';
import MenuReturn from '../../components/console-common/menu-return.vue';
import IndicatorOverview from '../../components/ins-claim/claim-indicators.vue';
import GraphHistogram from '../../components/ins-claim/graph-histogram.vue';
import GraphBar from '../../components/ins-claim/graph-bar.vue';
import { transBarOptions, formatHistogramData, formDefaultSearchDate, formatTime, } from './trans-data-util';
import { chartHistogram } from './chart-config';
import { exportData } from './export-file';
import * as CLAIM_API from './claim-api';
import * as TIPS from './const-tips';
var scaleTimeEfficiency = [
    {
        dataKey: 'category',
        alias: '保险公司',
    },
    {
        dataKey: 'value',
        alias: '理赔时效',
        formatter: function (value) { return formatTime(value); },
    },
];
export default Vue.extend({
    props: {
        searchParam: {
            type: Object,
            default: null,
        },
    },
    components: {
        'el-menu-return': MenuReturn,
        'el-indicator-overview': IndicatorOverview,
        'chart-histogram': GraphHistogram,
        'chart-bar': GraphBar,
    },
    computed: __assign({}, mapState('vinsurance', ['rentCompanyList', 'insCompanyList'])),
    data: function () {
        return {
            searchDefaultParam: {},
            localParams: {},
            titleConfig: {
                backTitle: '返回数据看板',
                currentTitle: '案均理赔时效',
                routerName: true,
                name: 'claimBoard',
            },
            indicators: [
                {
                    span: 4,
                    label: '万元以下赔付时效',
                    value: '--',
                    type: 'bar',
                    custFont: true,
                    tips: TIPS.TipHomeExpiredTotalClaim,
                },
            ],
            tipsRank: TIPS.TipSubEfficiencyTrend,
            tipsTop: TIPS.TipsSubEfficiencyRank,
            activeRankTab: '',
            rankTabs: [
                {
                    label: '0-2000元',
                    name: 'tab2k',
                },
                {
                    label: '2001-5000元',
                    name: 'tab5k',
                },
                {
                    label: '5001-10000元',
                    name: 'tab10k',
                },
                {
                    label: '10000+',
                    name: 'tab10kp',
                },
            ],
            barExpireScale: [{}],
            histogramChartOptions: chartHistogram,
            payEfficiencyData: null,
            chartBarOptions: null,
        };
    },
    methods: {
        formParams: function () {
            return this.localParams;
        },
        setParams: function (params) {
            this.localParams = params;
        },
        setupParams: function () {
            if (!this.insCompanyList || this.insCompanyList.length === 0) {
                this.$store.dispatch('vinsurance/GET_INS_COMPANYS'); // 获取保险公司选项
            }
            if (!this.rentCompanyList || this.rentCompanyList.length === 0) {
                this.$store.dispatch('vinsurance/GET_RENT_COMPANYS'); // 获取租赁公司选项
            }
            if (!this.searchParam) {
                this.setParams(formDefaultSearchDate());
            }
        },
        initIndicatorDefault: function () {
            this.searchDefaultParam = this.formParams();
        },
        handleSearch: function (params) {
            this.setParams(params);
            this.onFreshPage();
        },
        // 刷新整个页面
        onFreshPage: function () {
            var params = this.formParams();
            var ovParams = __assign({}, params, { overviewType: CLAIM_API.OVER_VIEW_EFFICIENCY });
            this.loadOverview(ovParams);
            this.loadInsEfficentTrend(params);
            this.queryCaseEfficiencyRank(params);
        },
        // 价格Tab
        handleRankTab: function (tab, event) {
            this.activeRankTab = tab.name;
            this.showCurrentBar();
        },
        showCurrentBar: function () {
            var insData = [];
            if (this.payEfficiencyData instanceof Array &&
                this.payEfficiencyData.length > 0) {
                var rawData = void 0;
                if (this.activeRankTab === this.rankTabs[0].name) {
                    rawData = this.payEfficiencyData[0].claimAgingTrendCompanyList;
                }
                else if (this.activeRankTab === this.rankTabs[1].name) {
                    rawData = this.payEfficiencyData[1].claimAgingTrendCompanyList;
                }
                else if (this.activeRankTab === this.rankTabs[2].name) {
                    rawData = this.payEfficiencyData[2].claimAgingTrendCompanyList;
                }
                else if (this.activeRankTab === this.rankTabs[3].name) {
                    rawData = this.payEfficiencyData[3].claimAgingTrendCompanyList;
                }
                else {
                    rawData = this.payEfficiencyData[0].claimAgingTrendCompanyList;
                }
                rawData.sort(function (a, b) {
                    return a.avgTimeCost < b.avgTimeCost
                        ? -1
                        : a.avgTimeCost > b.avgTimeCost
                            ? 1
                            : 0;
                });
                rawData.slice(0, 10).forEach(function (item, index) {
                    insData.push({
                        category: item.inscompanyName || item.inscompanyCode,
                        value: item.avgTimeCost,
                    });
                });
            }
            this.chartBarOptions = transBarOptions(insData, scaleTimeEfficiency, true);
        },
        loadOverview: function (params) {
            var _this = this;
            CLAIM_API.queryClaimOverview(params).then(function (res) {
                if (!res || !res.data || !res.data.averageOverview)
                    return;
                if (res.errorCode)
                    return;
                var claimAgingDisplay = res.data.averageOverview.claimAgingDisplay;
                _this.indicators[0].value = claimAgingDisplay;
            });
        },
        loadInsEfficentTrend: function (params) {
            var _this = this;
            CLAIM_API.queryCaseEfficiencyTrend(params).then(function (res) {
                if (!res || !res.data || !res.data.claimAgingTrendList)
                    return;
                if (res.errorCode)
                    return;
                _this.histogramChartOptions.data = formatHistogramData(res.data.claimAgingTrendList);
            });
        },
        // 5.2案均理赔时效保司排名
        queryCaseEfficiencyRank: function (params) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.$request({
                                url: '/proxy/insClaim/statistics/claimAgingRanking',
                                method: 'post',
                                data: params,
                            }).then(function (res) {
                                if (!res)
                                    return;
                                if (res.errorCode)
                                    return;
                                _this.payEfficiencyData = res.data.claimAgingTrendList;
                                if (!_this.chartBarOptions) {
                                    _this.showCurrentBar();
                                }
                                return res;
                            })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        // 下载
        exportFile: function () {
            var params = this.formParams();
            exportData(params);
        },
    },
    mounted: function () {
        this.setupParams();
        if (this.searchParam) {
            this.setParams(this.searchParam);
        }
        this.initIndicatorDefault();
        this.activeRankTab = this.rankTabs[0].name;
        this.onFreshPage();
    },
});
